import React from "react";

export default function ColorFrame1({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <circle cx="6.06602" cy="17.1944" r="6.06602" fill="#3CB8B4" />
        <circle cx="24.2641" cy="16.1834" r="16.176" fill="#7A6FF7" />
        <circle cx="10.6155" cy="27.8098" r="9.60452" fill="#FB6FBB" />
        <circle cx="54.0887" cy="11.6338" r="7.58252" fill="#FFC444" />
        <circle cx="40.44" cy="7.08431" r="5.05501" fill="#B150D2" />
        <circle cx="7.07699" cy="44.4915" r="5.05501" fill="#7A6FF7" />
        <circle cx="9.09899" cy="47.5245" r="3.03301" fill="#E38DDD" />
        <circle
          cx="269.938"
          cy="257.813"
          r="6.06602"
          transform="rotate(-180 269.938 257.813)"
          fill="#FFC444"
        />
        <circle
          cx="251.74"
          cy="258.824"
          r="16.176"
          transform="rotate(-180 251.74 258.824)"
          fill="#7A6FF7"
        />
        <circle
          cx="265.388"
          cy="247.197"
          r="9.60452"
          transform="rotate(-180 265.388 247.197)"
          fill="#B150D2"
        />
        <circle
          cx="221.915"
          cy="263.373"
          r="7.58252"
          transform="rotate(-180 221.915 263.373)"
          fill="#3CB8B4"
        />
        <circle
          cx="235.564"
          cy="267.923"
          r="5.05501"
          transform="rotate(-180 235.564 267.923)"
          fill="#FB6FBB"
        />
        <circle
          cx="268.927"
          cy="230.516"
          r="5.05501"
          transform="rotate(-180 268.927 230.516)"
          fill="#7A6FF7"
        />
        <circle
          cx="266.905"
          cy="227.483"
          r="3.03301"
          transform="rotate(-180 266.905 227.483)"
          fill="#E38DDD"
        />
        <circle
          r="6.06602"
          transform="matrix(-1 0 0 1 269.938 17.1944)"
          fill="#3CB8B4"
        />
        <circle
          r="16.176"
          transform="matrix(-1 0 0 1 251.74 16.1834)"
          fill="#7A6FF7"
        />
        <circle
          r="9.60452"
          transform="matrix(-1 0 0 1 265.388 27.8098)"
          fill="#FFC444"
        />
        <circle
          r="7.58252"
          transform="matrix(-1 0 0 1 221.915 11.6338)"
          fill="#FB6FBB"
        />
        <circle
          r="5.05501"
          transform="matrix(-1 0 0 1 235.564 7.08431)"
          fill="#B150D2"
        />
        <circle
          r="5.05501"
          transform="matrix(-1 0 0 1 268.927 44.4915)"
          fill="#7A6FF7"
        />
        <circle
          r="3.03301"
          transform="matrix(-1 0 0 1 266.905 47.5245)"
          fill="#3CB8B4"
        />
        <circle
          r="6.06602"
          transform="matrix(1 0 0 -1 6.06602 257.813)"
          fill="#FFC444"
        />
        <circle
          r="16.176"
          transform="matrix(1 0 0 -1 24.2641 258.824)"
          fill="#7A6FF7"
        />
        <circle
          r="9.60452"
          transform="matrix(1 0 0 -1 10.6155 247.197)"
          fill="#3CB8B4"
        />
        <circle
          r="7.58252"
          transform="matrix(1 0 0 -1 54.0887 263.373)"
          fill="#FB6FBB"
        />
        <circle
          r="5.05501"
          transform="matrix(1 0 0 -1 40.44 267.923)"
          fill="#B150D2"
        />
        <circle
          r="5.05501"
          transform="matrix(1 0 0 -1 7.07699 230.516)"
          fill="#7A6FF7"
        />
        <circle
          r="3.03301"
          transform="matrix(1 0 0 -1 9.09899 227.483)"
          fill="#B150D2"
        />
        {children}
      </g>
    </svg>
  );
}
